<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Análises</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            {
                                text: 'Homepage',
                                disabled: false,
                                to: '/home',
                                exact: true,
                            },
                            {
                                text: 'Análises',
                                disabled: true,
                                exact: true,
                            },
                        ]"></v-breadcrumbs>
                    </div>
                    <div class="button-group" style="padding-right: 16px;">
                        <v-btn v-if="$check(user, ['reportanalysis.create'])"
                        id="btnNew" type="button" color="primary" elevation="0" to="/analise-relatorio/novo">Incluir</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card class="table-card">
                    <v-card-title class="filter-card-title">Filtros</v-card-title>
                    <v-form @submit.prevent="load()">
                        <v-divider class="mt-2"></v-divider>

                        <v-container>
                            <v-row class="mt-3">
                                <v-col cols="4" align-self="baseline">
                                    <v-text-field style="padding-left: 8px;" dense label="Procurar"
                                        v-model="dataList.filter.content" no-data-text="Nenhuma informação disponível" 
                                        hide-details outlined clearable @click:clear="clearNameSearch">
                                    </v-text-field>
                                </v-col>

                                <v-spacer></v-spacer>

                                <v-col v-if="hasFilters()" cols="auto" style="padding-right: 1px;">
                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-btn v-on="on" id="btnClearFilter" type="button" outlined color="primary"
                                                @click="clearFilters">
                                                Limpar</v-btn>
                                        </template>
                                        <span>Limpar filtros de busca selecionados</span>
                                    </v-tooltip>
                                </v-col>

                                <v-col cols="auto" style="padding-right: 16px;">
                                    <v-btn id="btnFilter" type="submit" color="primary" dark
                                        elevation="2">Filtrar</v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>

                    <v-card-title class="table-card-title">Análises</v-card-title>
                    <v-card-text>
                        <v-data-table :headers="dataList.headers" :items="dataList.data"
                            :server-items-length="dataList.count" @update:items-per-page="pageSizeChanged"
                            @update:page="pageChanged" :disable-sort="true" :loading="dataList.loading"
                            no-data-text="Nenhuma análise foi encontrada" loading-text="Carregando dados..."
                            class="app-table hover-table" :options.sync="dataList.options"
                            :footer-props="dataList.footerOptions">
                            <template v-slot:[`item.name`]="{ item }">
                                <span class="ml-4 list-item-title">{{ item.name }}</span><br />
                            </template>

                            <template v-slot:[`item.created_at`]="{ item }">
                                {{ item.created_at | defaultDate("DD/MM/YYYY HH:mm:ss") }}
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-icon v-if="!$check(user, ['roles.update'])"
                                    :disabled="!$check(user, ['roles.find'])"
                                    @click="viewItem(item)" size="large" class="me-2">
                                    mdi-eye-outline
                                </v-icon>
                                <v-icon :disabled="(!$check(user, ['roles.update']))"
                                    @click="viewItem(item)" size="large"
                                    class="me-2">
                                    mdi-pencil-outline
                                </v-icon>
                                <v-icon :disabled="(!$check(user, ['roles.delete']))"
                                    @click="deleteItem(item)"
                                    size="large" class="me-2">
                                    mdi-delete
                                </v-icon>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

import object from "@/common/util/object"
import status from "@/common/data/user-status.data";
import userTypes from "@/common/data/user-types.data";

// import CardItemA from "@/layouts/components/CardItemA";

Vue.use(VueLodash)

export default {
    name: "UserList",

    // components: {
    //     CardItemA,
    // },

    data: () => ({
        user: null,
        dataset: {
            status: [{ id: "", name: "Todos" }, ...status],
            userTypes: userTypes,
            clients: [],
            units: [],
            data: {}
        },
        dataList: {
            filter: {
                content: "",
            },
            headers: [
                { text: "Nome", value: "name" },
                { text: "Criado em", value: "created_at" },
                { text: 'Ações', value: 'actions', sortable: false },
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                itemsPerPage: 10,
                sortBy: ['name'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
            }
        },
    }),

    created() {
        this.load();
    },

    methods: {
        pageChanged(page) {
            this.dataList.options.page = page;
            this.load();
        },

        pageSizeChanged(size) {
            this.dataList.options.itemsPerPage = size;
            this.load(true);
        },

        goBack() {
            this.$router.replace("/analise-relatorio");
        },

        hasFilters() {
            return Object.values(this.dataList.filter).some(value => value !== "");
        },

        clearFilters() {
            Object.keys(this.dataList.filter).forEach(key => {
                this.dataList.filter[key] = "";
            });
            this.load();
        },

        clearNameSearch() {
            this.dataList.filter.content = "";
            this.load();
        },

        debounce: _.debounce(function () {
            this.reload();
        }, 500),

        reload: function () {
            this.load();
        },

        async load() {
            this.user = this.$root.user.data || this.$root.user;

            let search = Object.fromEntries(Object.entries(this.dataList.filter).filter(([_, v]) => v))

            search = !object.isEmpty(search) ? search : null;

            this.dataList.loading = true;

            var limit = this.dataList.options.itemsPerPage;

            try {
                const result = await axios.get('/api/admin/report-analysis', { params: { page: this.dataList.options.page, limit: limit, search: search } });

                this.dataList.data = result.data.content.data;
                this.dataList.count = result.data.content.paging.total;

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }

        },

        async deleteItem(item) {
            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja realmente deletar esta análise? Esta ação não pode ser desfeita.',
                title: 'Deletar análise',
                actions: {
                    false: 'Cancelar',
                    true: 'Deletar',
                },
            });

            if (!proceedAction) return;

            try {
                //console.log("id:", item.id)
                const response = await axios.delete(`/api/admin/report-analysis/${item.id}`);

                this.$dialog.notify.info(response.data.message || 'Análise deletada com sucesso!', {
                    position: 'top-right',
                    timeout: 2000,
                });

                this.$router.go(0);
            } catch (error) {
                this.$dialog.notify.error('Erro ao deletar a análise.', {
                    position: 'top-right',
                    timeout: 2000,
                });
            }
        },

        viewItem(item) {
            this.$router.push(`analise-relatorio/${item.id}`);
        },
    },
};
</script>